/* @ngInject */
function RecoverPasswordController ($scope, $timeout, $state, $stateParams, $translate, $location, ConnectorWebService, CONSTANTS, Utils, MessageService, ToastService, AuthService, StrongPasswordService, BackendErrorParserService) {
  var sHost = $location.host()
  $scope.subdomain = ''
  $scope.sCustomerLogoPath = ''
  $scope.backgroundImageUrl = ''
  $scope.backgroundUrl = ''
  $scope.wrongMessage = ''
  $scope.changePassword = {
    password: '',
    passwordConfirm: ''
  }
  $scope.flags = {
    loadingLogo: true,
    loadingBackground: true,
    passwordAlreadyUsedError: false
  }

  $scope.passwordRules = {
    eight: false,
    uppercase: false,
    lowercase: false,
    number: false,
    special: false
  }
  $scope.strongPasswordEnabled = false
  $scope.passwordStrength = 'NONE' // NONE, ONE, TWO, THREE, FOUR, FIVE

  activate()

  function activate () {
    AuthService.setContainerPosition()
    AuthService.getCustomerImages(sHost)
      .then(url => {
        $scope.subdomain = localStorage.getItem('companySubdomain')
        $scope.sCustomerLogoPath = url.logo
        $scope.backgroundUrl = url.background
      })

    StrongPasswordService.checkIfNeedsStrongPassword($stateParams.token).then(info => {
      $scope.strongPasswordEnabled = info.hasStrongPasswordActive
    })
  }

  $scope.onLogoLoad = function () {
    $timeout(() => {
      $scope.flags.loadingLogo = false
    })
  }

  $scope.onBackgroundLoad = function () {
    $timeout(() => {
      $scope.backgroundImageUrl = $scope.backgroundUrl
      $scope.flags.loadingBackground = false
    })
  }

  $scope.onConfirmPasswordChange = function (evt) {
    $scope.changePassword.passwordConfirm = evt.detail.value
  }

  $scope.onPasswordChange = function (evt) {
    $scope.changePassword.password = evt.detail.value
    if ($scope.strongPasswordEnabled) {
      $scope.passwordStrength = StrongPasswordService.verifyPasswordStrength($scope.changePassword.password, $scope.passwordRules)
    }
  }

  $scope.fnChangePassword = function () {
    if ($scope.changePassword.password.length < 6) {
      $scope.wrongMessage = $translate.instant('passwordLengthMsg')
    } else if (
      $scope.changePassword.password !== $scope.changePassword.passwordConfirm
    ) {
      $scope.wrongMessage = $translate.instant('passwordsDontMatchMsg')
    } else {
      $scope.flags.passwordAlreadyUsedError = false
      var sUrl = Utils.fnReplaceStringParams(
        CONSTANTS.URL_AUTH_RECOVER_TOKEN,
        [$stateParams.token]
      )
      ConnectorWebService.post(sUrl, {
        password: $scope.changePassword.password
      }).then(
        function (res) {
          $scope.changePassword.password = ''
          $scope.changePassword.passwordConfirm = ''
          $scope.wrongMessage = ''
          MessageService.success({
            title: $translate.instant('successTitle'),
            text: $translate.instant(
              'yourPasswordWasModifiedSuccessfullyMsg'
            ),
            confirmButton: $translate.instant('loginToYourAccount'),
            press: function () {
              $state.go('login')
            }
          })
        },
        function (error) {
          if (error && error.status === 404) {
            $scope.wrongMessage = $translate.instant('yourTokenExpiredRequestNewMsg')
          } else if (BackendErrorParserService.passwordAlreadyUsed(error)) {
            $scope.flags.passwordAlreadyUsedError = true
          } else {
            ToastService.defaultErrorToast()
          }
        }
      )
    }
  }

  $scope.showPasswordTooltip = function () {
    if ($scope.strongPasswordEnabled) {
      $('.auth-container .strong-password-tooltip').removeClass('hidden-tooltip')
    }
  }

  $scope.hidePasswordTooltip = function () {
    if ($scope.strongPasswordEnabled) {
      $('.auth-container .strong-password-tooltip').addClass('hidden-tooltip')
    }
  }

  $scope.isButtonDisabled = function () {
    const inputsEmpty = !$scope.changePassword.password || !$scope.changePassword.passwordConfirm
    let passwordRulesNotChecked = false
    if ($scope.strongPasswordEnabled) {
      passwordRulesNotChecked = $scope.passwordStrength !== 'FIVE'
    }

    return inputsEmpty || passwordRulesNotChecked
  }
}

export { RecoverPasswordController }
